import React, { useState } from "react";
import Refresh from "assets/images/Refresh.svg";
import { Modal, Form } from "react-bootstrap";
// import SRTrackingList from "./SRTrackingList";
import MachineHistoryList from "./MachineHistoryList";

function MachineHistory(props) {
  const [showHistory, setShowHistory] = useState(false);
  const handleShowHistory = () => {
    setShowHistory(!showHistory);
  };
  return (
    <>
      <span onClick={handleShowHistory} className="highlightText me-2"  title="Machine History">
        <img src={Refresh} />
      </span>
      <Modal
        show={showHistory}
        onHide={handleShowHistory}
        centered
        dialogClassName="modal-800w"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fs-17 fw-semibold">
            Machine History -({props.sr_number})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MachineHistoryList machineId={props.machineId} />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default MachineHistory;
